module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue2-google-maps/~/core-js/library/modules/$.html.js
// module id = 287
// module chunks = 1